import { Checkbox } from '@consta/uikit/Checkbox';
import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import type { ICheckedObjectsCellRendererProps, IObjectTableColumnsProps } from '../../../helpersAndTypes';

const CheckboxRenderer = (props: ICheckedObjectsCellRendererProps) => {
    const { checkedObjects, data, onChangeCheckedObjects } = props;

    const onChangeCreator = useCallback(
        (id: number) =>
            ({ checked }: { checked: boolean }) => {
                onChangeCheckedObjects({
                    [id]: checked,
                });
            },
        [onChangeCheckedObjects],
    );

    const isChecked = useMemo(
        () => Boolean(checkedObjects[data.id] !== 'intermediate' && checkedObjects[data.id]),
        [checkedObjects, data.id],
    );
    const isIntermediate = useMemo(() => checkedObjects[data.id] === 'intermediate', [checkedObjects, data.id]);

    return <Checkbox onChange={onChangeCreator(data.id)} checked={isChecked} intermediate={isIntermediate} />;
};

export const useObjectTableColumns = ({ checkedObjects, onChangeCheckedObjects }: IObjectTableColumnsProps) =>
    useMemo<ColDef[]>(
        () => [
            {
                field: 'menu' as any,
                headerName: '',
                width: 55,
                resizable: false,
                pinned: 'left',
                lockPosition: 'left',
                cellRenderer: CheckboxRenderer,
                cellRendererParams: {
                    checkedObjects,
                    onChangeCheckedObjects,
                },
            },
            {
                field: 'name',
                headerName: 'Наименование объекта/подобъектов',
                flex: 1,
                cellStyle: (cellParams) => ({
                    paddingLeft: `${(cellParams?.data?.level ?? 0) * 30 + 20}px`,
                }),
                resizable: false,
            },
        ],
        [checkedObjects, onChangeCheckedObjects],
    );

CheckboxRenderer.displayName = 'CheckboxRenderer';
